import React, { useState, useEffect} from 'react';
import { Link } from 'react-router-dom';

export default function Infinityen() {
  const [pressimages, setPressimages] = useState([]);
  

  // Bilder aus infinity.json laden
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch('/data/infinity.json', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
            'Pragma': 'no-cache'
          }
        });
        if (!res.ok) throw new Error('Fehler beim Laden von infinity.json');
        const json = await res.json();
        setPressimages(json.images || []);
      } catch (err) {
        console.error(err);
      } finally {
       
      }
    };

    fetchImages();
  }, []);



  return (
  
    <article className="container">
        <div className="lang-switch">
        <Link to="/InfinityDe">
          <button>DE</button>
        </Link>
      </div>
     <header>
  <h1>Infinity of Light</h1>
  <h2>A light sculpture by Billi Thanner on the Votive Church, Vienna</h2>
  <p className="illumination">
    Illumination: December 16, 2025, evening<br />
    Duration: August 1, 2026<br />
    Curator: Dr. Walter Seidl
  </p>
</header>


  <section className="text">
  <p>
    Symbols shape spaces, emotions, and collective ideas. With “Infinity of
    Light,” Billi Thanner expands this symbolic dimension with a new,
    monumental installation in public space. Four years after her highly
    acclaimed “Himmelsleiter” (Stairway to Heaven), the artist returns to the
    towers of the Votivkirche (Votive Church) and continues her dialogue
    between architecture, perception, and urban context.
  </p>

  <p>
    The 28 × 8-meter aluminium sculpture in the shape of a horizontal
    eight—a symbol of infinity since ancient times—bathed in warm white
    light combines mathematical precision with poetic openness. A physical
    reference point is the time it takes for a ray of light to travel from
    the sun to the earth: eight minutes. Thanner transforms this constant
    into a spatial metaphor for continuity, balance, and connection, without
    religious or ideological exaggeration.
  </p>

  <p>
    “The work opens up a space of perception – between construction, light,
    and us humans,” explains Thanner.
  </p>

  <p>
    The sculpture enters into a lively dialogue with the neo-Gothic
    architecture of the Votive Church, creating a contemporary contrast
    that accentuates the urban space in a new way.
  </p>

  <p>
    “Infinity of Light is not primarily an invitation to look, but a
    reminder of the light that connects us,” says Billi Thanner.
    The artwork was created with private funding; the artist waived her fee
    and declined public and church subsidies. This independence manifests
    Thanner's consistent claim to think of art as a free, independent
    impulse.
  </p>

  <p>
    The artist comments: “Art should be visible to everyone who wants to
    see it.”
  </p>

  <p>
    In art-historical discourse, the work moves between minimalism, light
    art, and conceptual sculpture. The reclining eight is transformed into
    an architectural structure—a horizontal line between two vertical
    towers. In this way, the work addresses fundamental questions of scale,
    perception, and temporary art in public space.
  </p>

  <p>
    Billi Thanner (1972) lives and works in Vienna and is one of the
    protagonists of a new generation of contemporary actionism,
    neo-actionism, and interactionism.
  </p>
  
<p>    <br/> <br/> <br/>
  The following images are available for download in high resolution. 
  They can be accessed via the <Link to="/Pressphotos">Pressphotos link</Link>.
</p>

</section>


      <section className="gallery">
        <div className="grid">
          {pressimages.map((img, i) => (
            <figure key={i} className="card">
              <img src={img.url} alt={img.alt || ''} loading="lazy" />
              {img.title && <figcaption>{img.title}</figcaption>}
            </figure>
          ))}
        </div>

          <div className="back-button">
      <Link to="/">
        <button>back</button>
      </Link>

      <style jsx>{`

        .back-button {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
        }

        .back-button button {
          background: #000;
          color: #fff;
          padding: 6px 14px;
          border-radius: 8px;
          font-size: 0.9rem;
          border: none;
          cursor: pointer;
          transition: opacity 0.25s ease;
        }

        .back-button button:hover {
          opacity: 0.8;
        }
      `}</style>
    </div>
      </section>

      <style jsx>{`
.container {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.5;
  font-size: 15px;
  font-family: 'FreeSans', sans-serif;
  color: #222;
}

.lang-switch {
  position: absolute;
  top: 20px;
  right: 20px;
}

.lang-switch button {
  background: #000;
  color: #fff;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 0.9rem;
  border: none;
  cursor: pointer;
  transition: opacity 0.25s ease;
}

.lang-switch button:hover {
  opacity: 0.8;
}

header h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  font-weight: 700;
}

header h2 {
  font-size: 1.4rem;
  margin-bottom: 16px;
  color: #555;
  font-weight: 400;
}

.illumination {
  color: #888;
  font-size: 0.9rem;
  margin-bottom: 20px;
}

.text p {
  margin-bottom: 0.9em;
  font-size: 0.95rem;
  color: #333;
}

h3 {
  margin-top: 2.5em;
  font-size: 1.8rem;
  color: #222;
  font-weight: 600;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-top: 32px;
}

figure {
  margin: 0;
  overflow: hidden;
  border-radius: 6px;
  background-color: #f5f5f5;
}

img {
  
height:auto;
  width:100%;
  display: block;
  transition: transform 0.3s ease;
}

img:hover {
  transform: scale(1.03);
}

figcaption {
  padding: 8px 10px;
  font-size: 0.85rem;
  color: #555;
}

/* Mobile Styles */
@media (max-width: 600px) {
  .container {
    padding: 16px;
    font-size: 14px;
    line-height: 1.4;
  }

  .text p {
    font-size: 0.78rem; /* noch kleiner für Mobile */
    margin-bottom: 0.8em;
  }

  .illumination {
    font-size: 0.85rem;
  }

  header h1 {
    font-size: 1.8rem;
  }

  header h2 {
    font-size: 1.1rem;
  }

  h3 {
    font-size: 1.4rem;
  }

  .grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  figcaption {
    font-size: 0.8rem;
  }
}
      `}</style>
    </article>
  );
}